import SaveButton from './SaveButton';

/**
 * CardSaveOverlay — small floating bookmark button positioned in the bottom-right
 * of a story/athlete/video card. Rendered as a SIBLING of the card's Link so
 * we avoid nesting <button> inside <a> (invalid HTML / hydration warning).
 *
 * Usage:
 *   <div className="relative">
 *     <Link to=...>...</Link>
 *     <CardSaveOverlay type="stories" id={story.id} />
 *   </div>
 *
 * Props mirror SaveButton; `position` lets callers nudge the overlay if a card
 * already has another bottom-right element.
 */
const CardSaveOverlay = ({ type, id, position = 'bottom-right', className = '' }) => {
  const pos = {
    'bottom-right': 'bottom-3 right-3',
    'top-right': 'top-3 right-3',
  }[position] || 'bottom-3 right-3';

  return (
    <div
      className={`absolute ${pos} z-10 ${className}`}
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
    >
      <SaveButton type={type} id={id} variant="icon" />
    </div>
  );
};

export default CardSaveOverlay;
